import React, { Component } from 'react'
import { connect } from 'react-redux'
import { GetBaseUrl } from '@/utils/ConfigHelper'

import { GetJoinProviders } from '../../utils/SignupProviders'

import './index.scss'
import i18n from '../../i18n'

class SignUpSelection extends Component {

    renderProviders = (item, style) => {
        const {
            className,
            i18nKey,
            label,
            icon,
            endpoint
        } = item

        return (
            <div
                className={`selection ${className}`}
                style={style}
                onClick={() => this.props.handleClickThirdPartyLogin(`${GetBaseUrl()}/${endpoint}`)}
            >
                <div className="img-wrapper">
                    <img src={icon} alt="" />
                </div>
                <span>{label || i18n.t(i18nKey)}</span>
            </div>
        )
    }

    render() {
        const { lang } = this.props
        const loginProviders = GetJoinProviders(lang)
        return (
            <div className={`sign-up-selection-root-container`}>
                {
                    loginProviders.map((item, index) => {
                        const style = {
                            animationDelay: `0.${index}s`,
                            zIndex: 100 + (loginProviders - index)
                        }
                        return this.renderProviders(item, style)
                    })
                }
                <div
                    className="selection email"
                    style={{
                        animationDelay: `0.${loginProviders.length}s`,
                        zIndex: 100
                    }}
                    onClick={this.props.handleSignUpDialogOpen}
                >
                    <div className="img-wrapper">
                        <img src="https://front.videomonster.com/images-u6yd72dy/common/v2-vimon-ai-color.svg" alt="" />
                    </div>
                    <span>{i18n.t("web.email.signup")}</span>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(SignUpSelection)